import { HttpErrorResponse } from '@angular/common/http';
import { IFinancialLineItemExtendedDTO } from '@modeso/types__aumico-lib-settings-be';
import { EntityState } from '@ngrx/entity';

export interface IFinancialLineItemState extends EntityState<IFinancialLineItemExtendedDTO> {
    activeFinancialLineItem?: IFinancialLineItemExtendedDTO;
    error?: HttpErrorResponse;
}
